import theia from "../corejs/index.js"

const components = [theia]

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (app, p) {
    if (install.installed) return
    // 遍历注册全局组件
    components.map(component => app.component(component.name, component))

    //注册js组件
    app.config.globalProperties.$theia = theia.load(p.env || {})

}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
    install,
    // 以下是具体的组件列表
    load: theia.load,
}